// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb[data-v-225e2360] {\n  height: 52px;\n  line-height: 52px;\n  width: 1190px;\n  margin: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
